import React, { SyntheticEvent } from 'react';
import { Box, Typography } from '@mui/material';
import RoleTypeTag from '../../components/RoleTypeTag';
import { CommonStyle } from '../../../../utils/muiStyle';
import MySkeleton from '../../../../components/Skeleton';
// import { useNavigate } from 'react-router';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';

interface UserCardProps {
  mem?: any;
  bio?: string;
  loading?: boolean;
  imageUrl?: string;
  category?: string;
  cardWidth?: string;
  cardHeight?: string;
  displayName?: string;
  communityMembers?: any;
  handleOnSelectMember?:any;
  allCommunityMembersList?: any;
}

const UserCard: React.FC<UserCardProps> = ({
  mem,
  bio,
  loading,
  imageUrl,
  category,
  cardWidth = '250px',
  cardHeight = '250px',
  displayName,
  handleOnSelectMember
}) => {

  const placeholder = "https://placehold.co/250x250?text=User";

  const finalImage = imageUrl && imageUrl.trim() !== ""
    ? imageUrl
    : placeholder;

  return (
    <Box
      sx={{
        width: cardWidth,
        height: cardHeight,
        p: '12px',
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '6px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        gap: '5px',
        cursor: loading ? 'default' : 'pointer'
      }}
      onClick={() => !loading && handleOnSelectMember(mem)}
    >
      {/* BACKGROUND IMAGE */}
      {!loading && (
        <img
          src={finalImage}
          alt={displayName}
          style={{
            width: '250px',
            height: '250px',
            position: 'absolute',
            left: 0,
            top: 0,
            objectFit: 'cover'
          }}
        />
      )}

      {/* GRADIENT */}
      <Box
        sx={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          left: 0,
          top: 0,
          background: 'linear-gradient(180deg, rgba(0,0,0,0) 35%, rgba(0,0,0,0.60) 95%)'
        }}
      />

      {/* CATEGORY PILL */}
      {!loading && (
        <Box
          sx={{
            px: '8px',
            py: '5px',
            background: '#444444',
            borderRadius: '20px',
            zIndex: 2,
            display: 'inline-flex'
          }}
        >
          <Typography
            sx={{
              color: '#FDFDFD',
              fontSize: '12px',
              fontWeight: 500,
              textTransform: 'uppercase',
              lineHeight: '14px'
            }}
          >
            {category || 'Member'}
          </Typography>
        </Box>
      )}

      {/* BOTTOM CONTENT */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          width: '100%',
          zIndex: 2
        }}
      >
        <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '5px' }}>
          <Typography
            sx={{
              color: '#FDFDFD',
              fontSize: '16px',
              fontWeight: 700,
              lineHeight: '16px'
            }}
          >
            {displayName}
          </Typography>

          <Typography
            sx={{
              color: '#FDFDFD',
              fontSize: '12px',
              fontWeight: 400,
              lineHeight: '12px'
            }}
          >
            {bio}
          </Typography>
        </Box>

        {/* CTA BUTTON WITH ICON */}
        <Box
          sx={{
            width: '40px',
            height: '40px',
            p: '5px',
            borderRadius: '9999px',
            background:
              'linear-gradient(180deg, var(--orange-500, #F79420) 0%, var(--orange-700, #F15A26) 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <ChatBubbleOutlineIcon
            sx={{ color: '#fff', width: 22, height: 22 }}
          />
        </Box>
      </Box>
    </Box>
  );
};


export default UserCard;
